
/**
 * Export `surfaces`.
 */

export const surfaces = {
  antislip: 'antislip',
  gloss: 'gloss',
  mate: 'mate',
  relief: 'relief',
  semiGloss: 'semi gloss',
  structured: 'structured'
} as const;
